// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
var ApiKey = 'm68fHxp8/qmNZy3nn9To7acJHr54p6cD2wXS8LTa13E=';
var ClientId = '46ffffc2-a86d-495c-841b-ad498433f417';
export const environment = {
  production: false,
  // apiUrl: 'http://192.168.0.30/pcc/donohoe-v4/api/v1/',
  // uploadUrl: 'http://192.168.0.30/pcc/donohoe-v4/api/v1/',
  // portalUrl: 'http://192.168.0.30/pcc/',
  // portalUrlWithSession: 'http://192.168.0.30/pcc/#/selectport',
  // siteUrl: 'http://192.168.0.30/pcc/beacon/#/'
  // https://pccnetwork.net/salon_api/api/v1/

  //192.168.1.24 
  // apiUrl: 'http://192.168.1.24/kallos_saloon_api/api/v1/',
  // apiUrl_multi: 'http://192.168.1.24/wfl_api/api/v1/',
  // loginUrl: 'http://192.168.1.24/wfl_api/api/v1/',
  // uploadUrl: 'http://192.168.1.24/kallos_saloon_api/api/v1/',
  // uploadDir: 'http://192.168.1.24/kallos_saloon_api/api/v1/upload/',
  // SMSgatewayCommonURL: 'http://smsssl.dial4sms.com/api/v2/',
  // getSMSTemplatePromotional: 'http://smsssl.dial4sms.com/api/v2/Template?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '',
  // // getSMSReport: 'http://smsssl.dial4sms.com/api/v2/SMS?ApiKey='+ApiKey+'&ClientId='+ClientId+'&start=0&length=1000000&fromdate=2024-01-01&enddate=2124-01-01',
  // getSMSTemplateTransactional: 'http://smsssl.dial4sms.com/api/v2/Template?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '',
  // getSMSReport: 'http://smsssl.dial4sms.com/api/v2/GetSMS?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '&start=0&length=1000000&fromdate=2024-01-01&enddate=2124-07-11',
  // getSMSCount: 'http://smsssl.dial4sms.com/api/v2/Balance?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '',
  // portalUrl: 'http://192.168.1.24/kallos/#/',
  // portalUrlWithSession: 'http://192.168.1.24/kallos/#/',
  // siteUrl: 'http://192.168.1.24/kallos/#/'


  apiUrl: 'http://45.126.252.117/kallos_saloon_api/api/v1/',
  apiUrl_multi: 'http://45.126.252.117/wfl_api/api/v1/',
  loginUrl: 'http://45.126.252.117/wfl_api/api/v1/',
  uploadUrl: 'http://45.126.252.117/kallos_saloon_api/api/v1/getStories',
  uploadDir: 'http://45.126.252.117/kallos_saloon_api/api/v1/upload/',
  SMSgatewayCommonURL: 'http://smsssl.dial4sms.com/api/v2/',
  getSMSTemplateTransactional: 'http://smsssl.dial4sms.com/api/v2/Template?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '',
  getSMSTemplatePromotional: 'http://smsssl.dial4sms.com/api/v2/Template?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '',
  // getSMSReport: 'http://smsssl.dial4sms.com/api/v2/SMS?ApiKey='+ApiKey+'&ClientId='+ClientId+'&start=0&length=1000000&fromdate=2024-01-01&enddate=2124-01-01',
  getSMSReport: 'http://smsssl.dial4sms.com/api/v2/GetSMS?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '&start=0&length=1000000&fromdate=2024-01-01&enddate=2124-07-11',
  getSMSCount: 'http://smsssl.dial4sms.com/api/v2/Balance?ApiKey' + ApiKey + '&ClientId=' + ClientId + '',
  portalUrl: 'http://45.126.252.117/kallos/#/',
  portalUrlWithSession: 'http://45.126.252.117/kallos/#/',
  siteUrl: 'http://45.126.252.117/kallos360/#/'



  // apiUrl: 'https://www.kalloscaresm.com/saloon_api/api/v1/',
  // apiUrl_multi: 'https://www.kalloscaresm.com/wfl_api/api/v1/',
  // loginUrl: 'https://www.kalloscaresm.com/wfl_api/api/v1/',
  // uploadUrl: 'https://www.kalloscaresm.com/saloon_api/api/v1/',
  // uploadDir: 'https://www.kalloscaresm.com/saloon_api/api/v1/upload/',
  // SMSgatewayCommonURL: 'https://smsssl.dial4sms.com/api/v2/',
  // getSMSTemplateTransactional: 'https://smsssl.dial4sms.com/api/v2/Template?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '',
  // getSMSTemplatePromotional: 'https://smsssl.dial4sms.com/api/v2/Template?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '',
  // // getSMSReport: 'https://smsssl.dial4sms.com/api/v2/SMS?ApiKey='+ApiKey+'&ClientId='+ClientId+'&start=0&length=1000000&fromdate=2024-01-01&enddate=2124-01-01',
  // getSMSReport: 'https://smsssl.dial4sms.com/api/v2/GetSMS?ApiKey=' + ApiKey + '&ClientId=' + ClientId + '&start=0&length=1000000&fromdate=2024-01-01&enddate=2124-07-11',
  // getSMSCount: 'https://smsssl.dial4sms.com/api/v2/Balance?ApiKey' + ApiKey + '&ClientId=' + ClientId + '',
  // portalUrl: 'https://www.kalloscaresm.com/#/',
  // portalUrlWithSession: 'https://www.kalloscaresm.com/#/',
  // siteUrl: 'https://www.kalloscaresm.com/#/'
};


// location.thekalloscare.in


// WEBPACK FOOTER //
// ./src/environments/environment.ts